import { Component, computed, Input } from '@angular/core'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'le-button',
  imports: [FaIconComponent],
  templateUrl: './le-button.component.html',
  styleUrl: './le-button.component.scss',
  standalone: true
})
export class LeButtonComponent {
  @Input() text?: string
  @Input() loading = false
  @Input() disabled = false
  @Input() icon?: IconProp
  @Input() color = 'blue'
  @Input() textColor = 'white'
  @Input() capitalize = false
  @Input() classes = ''

  private readonly cssGeneration = [
    'bg-le-orange-500 border-le-orange-500 hover:bg-le-orange-600 focus:ring-le-orange-300 dark:bg-le-orange-600 dark:border-le-orange-600 dark:hover:bg-le-orange-700 dark:focus:ring-le-orange-800',
    'bg-le-blue-500 border-le-blue-500 hover:bg-le-blue-600 focus:ring-le-blue-300 dark:bg-le-blue-600 dark:border-le-blue-600 dark:hover:bg-le-blue-700 dark:focus:ring-le-blue-800',
    'bg-blue-500 border-blue-500 hover:bg-blue-600 focus:ring-blue-300 dark:bg-blue-600 dark:border-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800',
    'bg-red-500 border-red-500 hover:bg-red-600 focus:ring-red-300 dark:bg-red-600 dark:border-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800',
    'text-white text-gray-900',
  ]

  $$colors = computed(() => {
    if (this.color === 'white') {
      return ' bg-white border border-gray-300 hover:bg-gray-100 focus:ring-gray-100 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700'
    }
    return `bg-${this.color}-500 border-${this.color}-500 hover:bg-${this.color}-600 focus:ring-${this.color}-300 dark:bg-${this.color}-600 dark:border-${this.color}-600 dark:hover:bg-${this.color}-700 dark:focus:ring-${this.color}-800`
  })
  $$computedClasses = computed(() => {
    return `${this.classes} ${this.$$colors()} ${this.$$textColors()}`
  })
  $$text = computed(() => {
    return this.capitalize ? this.text?.toUpperCase() : this.text
  })
  $$textColors = computed(() => {
    if (this.color === 'white') {
      return `${this.textColor} dark:text-white`
    }
    return `text-${this.textColor}`
  })
}
